import useTranslation from '@/hooks/useTranslation';
import classNames from '@/utils/classNames';
import styles from './ContactDetails.module.css';

export const ContactDetails = ({ className }: { className?: string }) => {
    const { t } = useTranslation();
    return (
        <div className="cds-container">
            <dl className={classNames(styles.list, className)}>
                <dt>EMEA</dt>
                <dd>+44 20 3216 4778</dd>
                <dt>AMER</dt>
                <dd>+1 212 617 1980</dd>
                <dt>APAC</dt>
                <dd>+81 3 3201 3112</dd>
                <dt>{t('common:Labels.email')}</dt>
                <dd>
                    <a href="mailto:support.bnef@bloomberg.net">support.bnef@bloomberg.net</a>
                </dd>
            </dl>
        </div>
    );
};
